<template lang="pug">
div.lmm-content-body-padded
  //- sub-header
  b-container(fluid)
    b-row
      b-col(cols="12")
        b-card.w-100(v-if="notice")
          div(slot="header") {{notice.notice_title}}
          div.notice-body(v-html="notice.notice_content")
          div.notice-action
            b-link(@click="$router.back()") {{$t('back')}}
            | &nbsp;&nbsp;&nbsp;&nbsp;
            router-link.card-link(:to="{name: 'notice'}") {{$t('list-of', {v: $t('notice')})}}

  regist-form(:show.sync="showRegistForm" :pk="pk" :form="form" @close="showRegistForm = false" @complete="complete")
</template>

<script>
import { NoticeAPI } from "@/api"
import RegistForm from "./regist"
import { user } from "@/api/access"

export default {
  name: "notice-detail",
  props: {
    pk: {
      type: [String, Number],
      required: true,
    },
  },
  components: {
    RegistForm,
  },
  mounted() {
    this.user = user()
    this.fetchData()
  },
  data() {
    return {
      user: null,
      showRegistForm: false,
      notice: null,
      form: {
        creator: "",
        title: "",
        content: "",
      },
    }
  },
  methods: {
    fetchData() {
      NoticeAPI.get(`${this.pk}`).then(resp => {
        if (resp.data && resp.data.objects && resp.data.objects.length > 0) {
          this.notice = resp.data.objects[0]
          this.form.creator = this.notice.creator || ""
          this.form.title = this.notice.notice_title || ""
          this.form.content = this.notice.notice_content || ""
        } else {
          console.error("Notice not found or invalid response structure")
          this.$router.back()
        }
      }).catch(error => {
        console.error("Failed to fetch notice:", error)
        this.$router.back()
      })
    },
    del() {
      let params = {
        context: {
          title: this.$t('support_page.delete_notice'),
          path: this.$t('support_page.confirm_deletion'),
        },
        withoutInput: true,
        submit: {
          size: "sm",
          color: "danger",
          text: { path: "delete" },
        },
      }
      this.AppState.$emit("show-confirm-dialog", params, (key, data) => {
        if (key !== "submit") return
        NoticeAPI.delete(`${this.pk}`).then(resp => {
          this.$router.back()
        })
      })
    },
    complete() {
      this.showRegistForm = false
      this.fetchData()
    },
  },
}
</script>

<style lang="scss" scoped>
.notice-body {
  white-space: pre-wrap;
}
.notice-action {
  padding-top: 15px;
  border-top: 1px solid #d2d2d2;
  text-align: right;
}
</style>
